
import { Alert, Box, Button, Card, CardContent, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, List, ListItem, ListItemIcon, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import axiosInstance from 'custom-axios';
import { checkboxColorSx, questionnaireNotesArray, radioColorSx, useOfAccountArray } from 'store/constant';
import DonutChart from 'views/charts/DonutChart';
import { useParams } from 'react-router';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
// import { InputLabel, OutlinedInput } from '@material-ui/core';
// import DeleteIcon from "@mui/icons-material/Delete"; // MUI Delete Icon
import NumberFormat from 'react-number-format';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';
import CheckIcon from '@mui/icons-material/Check';


const RiskQuestionnaire = ({ setActiveChildStep, activeChildStep, setActiveParentStep, activeParentStep }) => {


    const { id } = useParams();
    let userGetId = localStorage.getItem('user_get_id');
    const userId = id ? id : userGetId;
    let loginId = localStorage.getItem('login_id');

    // let loginType = localStorage.getItem('login_type');
    // let managerLoginId = localStorage.getItem('manager_id');
    // let managerId = loginType == 'client' ? loginId : (managerLoginId ? managerLoginId : 0);

    const [questionnaireData, setQuestionnaireData] = useState({});
    const [loadingQuestionData, setLoadingQuestionData] = useState(false);
    // const [chartValue, setChartValue] = useState([]);
    // const [chartTitle, setChartTitle] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [loadingChart, setLoadingChart] = useState(false)
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    // const [editMode, setEditMode] = useState(false);
    // const [editableValues, setEditableValues] = useState({});
    // const [portfolioName, setPortfolioName] = useState('');
    // const [currentNote, setCurrentNote] = useState(''); // For the textarea input
    // const [notesList, setNotesList] = useState({}); // For storing all notes

    const [openSelectBoxes, setOpenSelectBoxes] = useState({});
    const [portfolioStates, setPortfolioStates] = useState([]);
    const [titleNotes, setTitleNotes] = useState(Array(5).fill(""));
    const [riskCategoriesData, setRiskCategoriesData] = useState([])
    const [scoreErrorMessage, setScoreErrorMessage] = useState('')
    const [emailNotificationStatus, setEmailNotificationStatus] = useState(false)

    const fetchRiskCategories = async () => {

        try {
            const response = await axiosInstance.get(`api/risk-category-details`);

            if (response.success) {
                setRiskCategoriesData(response.data)
            }

        } catch (error) {
            // console.error(error);
        }
    };

    const fetchUserQuestionnaireData = async () => {

        try {
            const response = await axiosInstance.get(`api/user-questionnaire/${loginId}/${userId}`);

            setQuestionnaireData(response.data)

            if (response.graph_data.length > 0) {
                showPortfolio(response.graph_data)
            }

            setLoadingQuestionData(true)

        } catch (error) {
            // console.error(error.message)
        }
    }


    const fetchUserPortfolioNotes = async () => {

        try {

            const response = await axiosInstance.get(`api/get-user-portfolio-notes/${userId}`);

            if (response.status == 200) {
                // setNotesList(response.data)
                setTitleNotes(response.title_notes)
            }

        } catch (error) {
            // console.error(error.message)
        }
    }


    // const handleNoteChange = (e) => {
    //     setCurrentNote(e.target.value);
    // };

    const handleTitleNoteChange = (e, index) => {
        const newNotes = [...titleNotes];
        newNotes[index] = e.target.value;
        setTitleNotes(newNotes);
    };

    const handleNoteChange = (event, index) => {
        const { value } = event.target;

        setChartData((prevData) =>
            prevData.map((portfolio, idx) =>
                idx === index
                    ? {
                        ...portfolio,
                        chartData: {
                            ...portfolio.chartData,
                            account_portfolio_note: value,
                        },
                    }
                    : portfolio
            )
        );
    };

    const handleRoleBack = async () => {
        showLoader()
        // setActiveAccountStep(activeAccountStep - 1);
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: 6 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(1);
                setActiveChildStep(6)
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        } finally {
            hideLoader();
        }
    }

    const handleNextStep = async () => {
        showLoader();
        const endPoint = `api/save-client-questionnaire`;

        const submitData = {
            questionnaire_data: questionnaireData,
            title_notes: titleNotes,
            email_notification_status: emailNotificationStatus ? 1 : 0,
            user_id: userId ? userId : 0,
            parent_step: activeParentStep + 1,
            child_step: 0
        };

        try {

            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(activeParentStep + 1);
            }

        } catch (error) {
            // console.error(error);
            toast.error('An error occurred when navigating next.');
        } finally {
            hideLoader();
        }

    }

    const handlePortfolioCheckboxChange = (portfolioId, portfolioType, portfolioIndex) => {
        setPortfolioStates(prevState => ({
            ...prevState,
            [portfolioIndex]: {
                ...prevState[portfolioIndex],
                [portfolioType]: prevState[portfolioIndex][portfolioType].map(portfolio =>
                    portfolio.id === portfolioId
                        ? { ...portfolio, checked: !portfolio.checked }
                        : portfolio
                )
            }
        }));
    };

    const handlePortfolioTextChange = (portfolioId, portfolioType, portfolioIndex, allocation) => {
        setPortfolioStates(prevState => ({
            ...prevState,
            [portfolioIndex]: {
                ...prevState[portfolioIndex],
                [portfolioType]: prevState[portfolioIndex][portfolioType].map(portfolio =>
                    portfolio.id === portfolioId
                        ? { ...portfolio, allocation }
                        : portfolio
                )
            }
        }));
    };

    const enhancementPortfolioChange = async (event, index, accountTypeLabelId) => {

        const selectedValue = event.target.value;
        const currentPortfolio = chartData[index]?.chartData;

        if (!currentPortfolio?.all_portfolio) {
            toast.info('Please select all portfolio first.')
            return;
        }

        const updatedData = [...chartData];

        updatedData[index] = {
            ...updatedData[index],
            chartData: {
                ...updatedData[index].chartData,
                account_selected_portfolio: selectedValue, // Update the field
            },
        };

        setChartData(updatedData);

        setOpenSelectBoxes((prev) => ({
            ...prev,
            [index]: selectedValue,
        }));

        handlePortfolioChange(event, index, accountTypeLabelId);
    };

    const recommendedRiskCategoryChange = (event, index) => {
        const selectedValue = event.target.value;
        const updatedData = [...chartData];

        updatedData[index] = {
            ...updatedData[index],
            chartData: {
                ...updatedData[index].chartData,
                account_recommended_portfolio: selectedValue, // Update the field
            },
        };

        setChartData(updatedData);
    };

    const advisorRiskCategoryChange = async (event, index) => {
        const selectedValue = event.target.value;
        const updatedData = [...chartData];

        updatedData[index] = {
            ...updatedData[index],
            chartData: {
                ...updatedData[index].chartData,
                advisor_risk_category: selectedValue, // Update the field
            },
        };

        const endPoint = `api/save-questionnaire-advisor-portfolio`;

        const payloadData = {
            user_id: userId ? userId : 0,
            advisor_risk_category: selectedValue,
            account_type_portfolio_details_id: updatedData[index].chartData?.account_type_portfolio_details_id,
            // user_account_type_info_id: updatedData[index].chartData?.account_type_portfolio_details_id.
            user_account_type_info_id: updatedData[index].chartData.account_type_label_id,

        }

        try {

            showLoader();
            const response = await axiosInstance.post(endPoint, payloadData);

            if (response.success) {
                const selectedAnswers = questionnaireData.map(question => question.selected_answers);
                showPortfolio(selectedAnswers)
                toast.success(response.message);
            } else {
                toast.info(response.message || 'Please reset the enhanced portfolio first.')
            }
        } catch (error) {
            // console.error(error);
            toast.error('An error occurred while fetching the data.');
        } finally {
            hideLoader();
        }

        setChartData(updatedData);
    };


    const allPortfolioChange = async (event, index) => {
        const selectedValue = event.target.value;
        const updatedData = [...chartData];

        if (updatedData[index].chartData?.modified_portfolio === 1) {
            toast.info('Please reset the enhanced portfolio first.')
            return;
        }

        updatedData[index] = {
            ...updatedData[index],
            chartData: {
                ...updatedData[index].chartData,
                all_portfolio: selectedValue, // Update the field
            },
        };

        const endPoint = `api/questionnaire-account-all-portfolio`;

        const payloadData = {
            user_id: userId ? userId : 0,
            all_portfolio: selectedValue,
            account_type_portfolio_details_id: updatedData[index].chartData?.account_type_portfolio_details_id,
            user_account_type_info_id: updatedData[index].chartData.account_type_label_id,
        }

        showLoader();

        try {
            const response = await axiosInstance.post(endPoint, payloadData);

            if (response.success) {
                const selectedAnswers = questionnaireData.map(question => question.selected_answers);
                showPortfolio(selectedAnswers)
                toast.success(response.message);
            }
        } catch (error) {
            // console.error(error);
            toast.error('An error occurred while fetching the data.');
        } finally {
            hideLoader();
        }

        setChartData(updatedData);

    };

    const handlePortfolioChange = async (event, portfolioIndex, accountTypeLabelId) => {
        const { value } = event.target;

        const endPoint = `api/enhancement-portfolio-data/${value}/${accountTypeLabelId}`;

        showLoader();
        try {
            const response = await axiosInstance.get(endPoint); // Fetch data from the server

            if (response.success) {

                // we need only enhancement data
                // const selectedAnswers = questionnaireData.map(question => question.selected_answers);
                // showPortfolio(selectedAnswers)

                const fetchedData = response.data;

                setPortfolioStates(prevStates => ({
                    ...prevStates,
                    [portfolioIndex]: {
                        public: fetchedData.public.map(portfolio => ({
                            ...portfolio,  // No need to recreate manually, just spread existing data
                        })),
                        private: fetchedData.private.map(portfolio => ({
                            ...portfolio,  // Same here, spread the data as it is
                        }))
                    }
                }));

                if (response.message) {
                    toast.success(response.message);
                }
            } else {
                toast.info(response.message || 'Please select all portfolio first.')
            }
        } catch (error) {
            // console.error(error);
            toast.error('An error occurred while fetching the data.');
        } finally {
            hideLoader();
        }
    };


    const saveEnhancementPortfolio = (index, portfolioTypeId) => {

        const data = portfolioStates[index]
        const filteredPublicPortfolios = data.public.filter(portfolio => portfolio.checked);
        const filteredPrivatePortfolios = data.private.filter(portfolio => portfolio.checked);


        const isValidAllocation = (allocation) => {
            return allocation && !isNaN(allocation) && allocation > 0; // You can add more checks depending on your needs
        };

        // Filter portfolios that have a valid allocation
        const filteredPublicPortfoliosWithValidAllocations = filteredPublicPortfolios.filter(portfolio =>
            isValidAllocation(portfolio.allocation)
        );

        const filteredPrivatePortfoliosWithValidAllocations = filteredPrivatePortfolios.filter(portfolio =>
            isValidAllocation(portfolio.allocation)
        );

        if (filteredPublicPortfoliosWithValidAllocations.length === 0 && filteredPrivatePortfoliosWithValidAllocations.length === 0) {
            toast.error("Please ensure all portfolios have a valid allocation.");
            return; // Don't send the payload if no valid allocations exist
        }

        const totalAllocation = [
            ...filteredPublicPortfolios,
            ...filteredPrivatePortfolios
        ]
            .reduce((total, portfolio) => total + parseFloat(portfolio.allocation || 0), 0); // Sum the allocations


        if (totalAllocation > 20) {

            toast.error('Total allocation for public and private portfolios cannot exceed 20%.');
            return;
        }

        const payload = {
            allocations: [
                ...filteredPublicPortfoliosWithValidAllocations.map(portfolio => ({
                    portfolio_type_id: portfolioTypeId,
                    user_id: userId,
                    fund_id: portfolio.id,
                    id: portfolio.primary_id,
                    allocation: portfolio.allocation,
                    user_account_type_info_id: portfolio.user_account_type_info_id,
                    type: 2, //public
                })),
                ...filteredPrivatePortfoliosWithValidAllocations.map(portfolio => ({
                    portfolio_type_id: portfolioTypeId,
                    user_id: userId,
                    fund_id: portfolio.id,
                    id: portfolio.primary_id,
                    allocation: portfolio.allocation,
                    user_account_type_info_id: portfolio.user_account_type_info_id,
                    type: 1, //private
                })),
            ],
            unfiltered_data: data,
            user_id: userId,
            account_no: '',
            selected_portfolio: portfolioTypeId,
            account_holder: chartData[index].chartData.account_holder == 'Primary' ? 1 : 2,
            account_type: chartData[index].chartData.account_type == 'Non-Register' ? 1 : 2,// reg or non-reg
            account_type_id: chartData[index].chartData.selected_account_type,
            account_type_label_id: chartData[index].chartData.account_type_label_id,
            // enhancement_portfolio_id: portfolioTypeId,
            // account_type_portfolio_details_id: updatedData[index].chartData?.account_type_portfolio_details_id
        };

        showLoader()

        try {
            let endPoint = 'api/submit-user-enhanced-portfolio'

            const response = axiosInstance.post(endPoint, payload);
            const selectedAnswers = questionnaireData.map(question => question.selected_answers);

            response
                .then(responseData => {
                    showPortfolio(selectedAnswers)
                    hideLoader()
                    toast.success(responseData.message);
                })
                .catch(error => {
                    // hideLoader()
                    // console.error('Error occurred while saving portfolio:', error.message);
                });

        } catch (error) {
            // console.error(error)
        } finally {
            hideLoader();
        }
    };

    const resetEnhancementPortfolio = async (portfolioTypeId, index) => {

        const updatedData = [...chartData];

        const payload = {
            portfolio_type_id: portfolioTypeId,
            user_id: userId,
            account_no: '',
            account_type_id: updatedData[index].chartData.selected_account_type,
            account_type_portfolio_details_id: updatedData[index].chartData.account_type_portfolio_details_id,
            account_type_info_id: updatedData[index].chartData.account_type_label_id,

        }

        const selectedAnswers = questionnaireData.map(question => question.selected_answers);

        let endPoint = `api/reset-user-enhanced-portfolio`;

        const result = await showConfirmSweetAlert({
            title: 'Reset Portfolio?',
            text: 'Are you sure you want to reset this portfolio?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, reset it!',
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            showLoader()

            const response = axiosInstance.post(endPoint, payload);

            response
                .then(responseData => {

                    showPortfolio(selectedAnswers)

                    hideLoader()
                    toast.success(responseData.message);
                })
                .catch(error => {
                    hideLoader()
                    // console.error('Error occurred while saving portfolio:', error.message);
                });

            hideLoader();
        }
    }

    const handleChangeQuestion = (questionId, selectedOptionId) => {
        setQuestionnaireData(prevData =>
            prevData.map(question =>
                question.id === questionId ? { ...question, selected_answers: parseInt(selectedOptionId) } : question
            )
        );
    };



    const submitQuestion = async () => {

        const selectedAnswers = questionnaireData.map(question => question.selected_answers);

        if (selectedAnswers.includes(0)) {
            toast.error("To generate allocation please select your option for all questions.");
            return;
        }

        showPortfolio(selectedAnswers)
    };

    const handleSaveNotes = async (index) => {

        const endPoint = `api/save-client-portfolio-info`;

        const submitData = {
            user_id: userId ? userId : 0,
            updated_by: loginId,
            entry_for: 2,
            account_type_portfolio_details_id: chartData[index].chartData.account_type_portfolio_details_id,
            recommended_portfolio: chartData[index].chartData.account_recommended_portfolio,
            advisor_risk_category: chartData[index].chartData.advisor_risk_category,
            selected_portfolio: chartData[index].chartData.account_selected_portfolio,
            all_portfolio: chartData[index].chartData.all_portfolio,
            notes: chartData[index].chartData.account_portfolio_note,
            account_type: chartData[index].chartData.account_type == 'Non-Register' ? 1 : 2,// reg or non-reg
            account_type_id: chartData[index].chartData.selected_account_type, // type _id is TFSA or LIRA 
            // account_type_id: chartData[index].chartData.account_type_portfolio, 
            account_holder: chartData[index].chartData.account_holder == 'Primary' ? 1 : 2,
        };

        try {
            showLoader()
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.success) {
                toast.success(response.message);
            }

        } catch (error) {
            // console.error(error);
        } finally {
            hideLoader()
        }

    }

    // const roundPortfolioValue = (value) => Number(Number(value || 0).toFixed(2));


    const showPortfolio = async (selectedAnswers) => {

        let progressUrl = `api/user-recommended-portfolio`;
        try {
            showLoader()

            const data = {
                ...selectedAnswers,
                user_id: userId,
                is_add_or_update: true
            }

            const response = await axiosInstance.post(progressUrl, data);

            if (response.type === 'success') {

                const chartDataArray = response.data.map((portfolio, index) => {
                    let chartTitle = portfolio.assets.map((asset) => asset.title);
                    let chartValue = portfolio.assets.map((asset) => Number(asset.value));
                    let editableValues = portfolio.assets.reduce((acc, asset) => {
                        acc[asset.title] = asset.value;
                        return acc;
                    }, {});

                    setPortfolioStates(prevStates => ({
                        ...prevStates,
                        [index]: {
                            public: portfolio.enhancement_portfolio_details?.public ? portfolio.enhancement_portfolio_details.public.map(portfolioEnhancement => ({
                                ...portfolioEnhancement,  // No need to recreate manually, just spread existing data
                            })) : [],
                            private: portfolio.enhancement_portfolio_details?.private ? portfolio.enhancement_portfolio_details.private.map(portfolioEnhancement => ({
                                ...portfolioEnhancement,  // Same here, spread the data as it is
                            })) : []
                        }
                    }));

                    setOpenSelectBoxes((prev) => ({
                        ...prev,
                        [index]: portfolio.account_selected_portfolio,
                    }));


                    return {
                        chartData: portfolio,
                        chartTitle,
                        chartValue,
                        editableValues,
                    };
                });

                setScoreErrorMessage()
                setChartData(chartDataArray); // Store an array of portfolio data
                setLoadingChart(true);
            } else {
                setScoreErrorMessage(response.message)
                setChartData([]);
                setLoadingChart(false);
            }

        } catch (error) {
            // console.error("Error submitting questions:", error);
            toast.error("There was an error submitting your answers. Please try again.");
        } finally {
            hideLoader()
        }
    }

    async function fetchAllApi() {

        showLoader()
        await fetchUserQuestionnaireData()
        await fetchUserPortfolioNotes()
        await fetchRiskCategories()

        hideLoader()
    }

    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <>
            <div className='bg-white p-4'>
                <div>
                    <Grid className="form-head-gray-title mb-2" sx={{ padding: '15px 0 15px 20px !important' }}>
                        Questionnaire
                    </Grid>

                    <Grid sx={{ border: 'none', padding: 0 }}>

                        <Grid item xs={12} /* sx={{ padding: '10px', borderRadius: '10px', border: '1px solid #e0e0e0' }} */>
                            <FormControl>
                                {loadingQuestionData
                                    ? questionnaireData.map((question, index) => {
                                        return (
                                            <Grid sx={{ padding: '10px', borderRadius: '10px', border: '1px solid #e0e0e0', marginTop: '5px' }} key={question.id}>
                                                <FormLabel
                                                    id={`demo-controlled-radio-buttons-group${question.id}`}
                                                    className='black-text-1 font14px'
                                                >
                                                    {index + 1}. {question.question}
                                                </FormLabel>

                                                <RadioGroup
                                                    aria-labelledby={`questionnaire-controlled-radio-buttons-group_${question.id}`}
                                                    value={question.selected_answers}
                                                    name={`kyc_questions_${question.id}`}
                                                    onChange={(e) => handleChangeQuestion(question.id, e.target.value)}
                                                    sx={{ flexDirection: 'row', flexWrap: 'wrap' }}
                                                >
                                                    {question.options.map((option) => (
                                                        <FormControlLabel
                                                            className='margin-left20px'
                                                            key={option.id}
                                                            value={option.id} // Convert to string for Yup validation
                                                            control={<Radio sx={checkboxColorSx} />}
                                                            label={option.option}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </Grid>
                                        )
                                    }
                                    )
                                    : ''}
                            </FormControl>
                        </Grid>

                        {/* {loginType !== 'client' && */}
                        <Grid item xs={12} sm={12} className='pt-3 text-start'>
                            <Button variant='outlined' className='m-3' onClick={submitQuestion}>
                                Save Questionnaire
                            </Button>
                        </Grid>

                        {scoreErrorMessage && scoreErrorMessage !== '' && (
                            <Grid item xs={12} sm={12} className='pt-3 text-start'>
                                <Alert severity="info" className='m-3' sx={{ alignItems: 'center' }}>
                                    {scoreErrorMessage}
                                </Alert>
                            </Grid>
                        )}
                    </Grid>

                    {/* ------------------------END OF QUESTIONNAIRE ------------------------- */}

                    {(loadingChart) && (
                        <>
                            {chartData.map((portfolioData, portfolioIndex) => {

                                const collapseId = `collapse${portfolioIndex}`;

                                return (
                                    <>
                                        <Grid item xs={12} >

                                            <Grid spacing={2} className='mt-3 p-0' key={portfolioIndex}>

                                                <div className="card mt-3">
                                                    <div
                                                        className={`card-header risk-questionnaire-accordion fw-bold bg-light d-flex justify-content-between align-items-center cursor-pointer ${portfolioIndex !== 0 ? "collapsed" : ""}`}
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#${collapseId}`}
                                                    >
                                                        {/* LEFT SIDE (YOUR TITLE) */}
                                                        <span>
                                                            {portfolioData.chartData.full_name} : Account ({portfolioData.chartData.account_holder})
                                                            {' '} : {portfolioData.chartData.account_type_label} - {portfolioData.chartData.account_type}
                                                        </span>

                                                        {/* RIGHT SIDE (ARROW ICON) */}
                                                        <span className="risk-questionnaire-accordion-icon">▼</span>
                                                    </div>
                                                    <div id={collapseId} className={`collapse ${portfolioIndex === 0 ? "show" : ""}`}>
                                                        <div className="card-body">
                                                            {/* intended use of account data */}
                                                            <Grid item xs={12} sx={{ marginRight: 2, padding: '15px' }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                                    What are the intended use of the accounts?
                                                                </Typography>

                                                                <List dense>
                                                                    {useOfAccountArray
                                                                        .filter(option => portfolioData.chartData.intended_use_account.includes(option.value))
                                                                        .map(option => (
                                                                            <ListItem key={option.value} sx={{ pl: 0 }}>
                                                                                <ListItemIcon sx={{ minWidth: '30px' }}>
                                                                                    <CheckIcon fontSize="small" color="primary" />
                                                                                </ListItemIcon>
                                                                                <Typography variant="body2">{option.label}</Typography>
                                                                            </ListItem>
                                                                        ))}
                                                                </List>
                                                            </Grid>


                                                            {/* Data Row */}
                                                            <Grid item xs={12}>
                                                                <Grid container className="p-1 mt-2">
                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>

                                                                        <Grid item xs={12} md={8}>
                                                                            <Grid container spacing={2} sx={{ padding: '10px' }}>
                                                                                {["Recommended Risk Category", "Advisor's Risk Category", "All Portfolios"].map((text, index) => (
                                                                                    <Grid item xs={12} sm={4} key={index}>
                                                                                        <label className="label-text font14px">{text}</label>
                                                                                    </Grid>
                                                                                ))}

                                                                                <Grid item xs={12} sm={4}>
                                                                                    <FormControl sx={{ minWidth: '100%' }} size="small">
                                                                                        <InputLabel>Recommended Category</InputLabel>

                                                                                        <Select
                                                                                            label='Recommended Category'
                                                                                            disabled
                                                                                            value={portfolioData.chartData.account_recommended_portfolio || ''}
                                                                                            onChange={(e) => recommendedRiskCategoryChange(e, portfolioIndex)}
                                                                                            MenuProps={{
                                                                                                disableScrollLock: true,
                                                                                                PaperProps: { sx: { maxHeight: 200 } },
                                                                                            }}
                                                                                            inputProps={{ 'aria-label': 'Select Risk Category' }}
                                                                                        >
                                                                                            {riskCategoriesData?.map((option) => (
                                                                                                <MenuItem key={option.id} value={option.id}>
                                                                                                    {option.name}
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                </Grid>

                                                                                {/* Advisor Recommended Risk Category */}
                                                                                <Grid item xs={12} sm={4}>
                                                                                    <FormControl sx={{ minWidth: '100%' }} size="small">
                                                                                        <InputLabel>Risk Category</InputLabel>

                                                                                        <Select
                                                                                            label='Risk Category'
                                                                                            value={portfolioData.chartData.advisor_risk_category || ''}
                                                                                            onChange={(e) => advisorRiskCategoryChange(e, portfolioIndex)}
                                                                                            MenuProps={{
                                                                                                disableScrollLock: true,
                                                                                                PaperProps: { sx: { maxHeight: 200 } },
                                                                                            }}
                                                                                            inputProps={{ 'aria-label': 'Select Risk Category' }}
                                                                                        >
                                                                                            {riskCategoriesData?.map((option) => (
                                                                                                <MenuItem key={option.id} value={option.id}>
                                                                                                    {option.name}
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                </Grid>

                                                                                {/* all Portfolios */}
                                                                                <Grid item xs={12} sm={4}>
                                                                                    <FormControl sx={{ minWidth: '100%' }} size="small">
                                                                                        <InputLabel>Select Portfolio</InputLabel>

                                                                                        <Select
                                                                                            label='Select Portfolio'
                                                                                            displayEmpty
                                                                                            value={portfolioData.chartData.all_portfolio || ''}
                                                                                            classes={{ select: "custom-select-label" }}
                                                                                            MenuProps={{
                                                                                                disableScrollLock: true,
                                                                                                PaperProps: { sx: { maxHeight: 200 } },
                                                                                            }}
                                                                                            inputProps={{ 'aria-label': 'Without label' }}
                                                                                            onChange={(e) => allPortfolioChange(e, portfolioIndex)}

                                                                                        >
                                                                                            {portfolioData.chartData.portfolio_name_list?.map((option) => (
                                                                                                <MenuItem key={option.portfolio_type_id} value={option.portfolio_type_id}>
                                                                                                    {option.portfolio_name}
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} md={4}>
                                                                            <Grid container spacing={2} sx={{ padding: '10px' }}>
                                                                                <Grid item xs={12}>
                                                                                    {["Select Enhanced Portfolio"].map((text, index) => (
                                                                                        <Grid item xs={12} sm={12} key={index}>
                                                                                            <label className="label-text font14px">{text}</label>
                                                                                        </Grid>
                                                                                    ))}
                                                                                </Grid>

                                                                                <Grid item xs={12}>
                                                                                    <FormControl sx={{ minWidth: 300 }} size="small">
                                                                                        <InputLabel>Select Enhanced Portfolio</InputLabel>

                                                                                        <Select
                                                                                            label='Select Enhanced Portfolio'
                                                                                            displayEmpty
                                                                                            disabled={!portfolioData.chartData.all_portfolio}
                                                                                            value={portfolioData.chartData.account_selected_portfolio || ''}

                                                                                            classes={{ select: "custom-select-label" }}
                                                                                            MenuProps={{
                                                                                                disableScrollLock: true,
                                                                                                PaperProps: { sx: { maxHeight: 200 } },
                                                                                            }}
                                                                                            inputProps={{ 'aria-label': 'Without label' }}
                                                                                            onChange={(e) => enhancementPortfolioChange(e, portfolioIndex, portfolioData.chartData?.account_type_label_id)}

                                                                                        >
                                                                                            {portfolioData.chartData?.portfolio_name_list?.map((option) => (
                                                                                                option.portfolio_plus_name &&
                                                                                                (<MenuItem key={option.portfolio_type_id} value={option.portfolio_type_id}>
                                                                                                    {option.portfolio_plus_name ? option.portfolio_plus_name : ''}
                                                                                                </MenuItem>)
                                                                                            ))}
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>

                                                                    </Box>
                                                                </Grid>
                                                            </Grid>


                                                            <Grid item xs={12} sx={{ paddingLeft: '16px', paddingRight: '16px' }}>
                                                                {openSelectBoxes[portfolioIndex] ? (
                                                                    <>
                                                                        <Grid item xs={12} className='mb-3 mt-3 text-right'>
                                                                            <Typography
                                                                                component={'h3'}
                                                                                sx={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', textTransform: 'capitalize' }} // Make it look like a link
                                                                                onClick={() => resetEnhancementPortfolio(portfolioData.chartData.account_selected_portfolio, portfolioIndex)}  // Call a method when clicked
                                                                            >
                                                                                Reset Portfolio
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Paper>

                                                                            <Grid container item xs={12} spacing={2}>
                                                                                {/* Public Portfolios Section */}
                                                                                <Grid item xs={6}>
                                                                                    <Typography variant="h4" component="h2" sx={{ marginTop: 2 }}>
                                                                                        Public
                                                                                    </Typography>

                                                                                    {portfolioStates[portfolioIndex]?.public?.map((portfolio) => (
                                                                                        <Grid container spacing={2} key={portfolio.id} sx={{ padding: '5px' }}>
                                                                                            <Grid item xs={8}>
                                                                                                <FormControlLabel
                                                                                                    control={
                                                                                                        <Checkbox
                                                                                                            sx={radioColorSx}
                                                                                                            checked={portfolioStates[portfolioIndex]?.public?.find(p => p.id === portfolio.id)?.checked || false}
                                                                                                            onChange={() => handlePortfolioCheckboxChange(portfolio.id, 'public', portfolioIndex)}
                                                                                                        />
                                                                                                    }
                                                                                                    label={`${portfolio.name} ${portfolio.symbol ? `(${portfolio.symbol})` : ''}`}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={4}>
                                                                                                <NumberFormat
                                                                                                    customInput={TextField}
                                                                                                    label="Allocation"
                                                                                                    variant="outlined"
                                                                                                    size="small"
                                                                                                    suffix={'%'}
                                                                                                    sx={{ width: 'auto' }}
                                                                                                    value={portfolioStates[portfolioIndex]?.public?.find(p => p.id === portfolio.id)?.allocation || ''}
                                                                                                    onValueChange={(values) => handlePortfolioTextChange(portfolio.id, 'public', portfolioIndex, values.value)}
                                                                                                    disabled={!portfolioStates[portfolioIndex]?.public?.find(p => p.id === portfolio.id)?.checked}
                                                                                                    inputProps={{ maxLength: 6 }}
                                                                                                    thousandSeparator={true}
                                                                                                    allowNegative={false}
                                                                                                />
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    ))}
                                                                                </Grid>

                                                                                {/* Private Portfolios Section */}
                                                                                <Grid item xs={6}>
                                                                                    <Typography variant="h4" component="h2" sx={{ marginTop: 2 }}>
                                                                                        Private
                                                                                    </Typography>

                                                                                    {portfolioStates[portfolioIndex]?.private?.map((portfolio) => (
                                                                                        <Grid container spacing={2} key={portfolio.id} sx={{ padding: '5px' }}>
                                                                                            <Grid item xs={8}>
                                                                                                <FormControlLabel
                                                                                                    control={
                                                                                                        <Checkbox
                                                                                                            sx={radioColorSx}
                                                                                                            checked={portfolioStates[portfolioIndex]?.private?.find(p => p.id === portfolio.id)?.checked || false}
                                                                                                            onChange={() => handlePortfolioCheckboxChange(portfolio.id, 'private', portfolioIndex)}
                                                                                                        />
                                                                                                    }
                                                                                                    label={`${portfolio.name} ${portfolio.symbol ? `(${portfolio.symbol})` : ''}`}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={4}>
                                                                                                <NumberFormat
                                                                                                    customInput={TextField}
                                                                                                    label="Allocation"
                                                                                                    variant="outlined"
                                                                                                    size="small"
                                                                                                    suffix={'%'}
                                                                                                    sx={{ width: 'auto' }}
                                                                                                    value={portfolioStates[portfolioIndex]?.private?.find(p => p.id === portfolio.id)?.allocation || ''}
                                                                                                    onValueChange={(values) => handlePortfolioTextChange(portfolio.id, 'private', portfolioIndex, values.value)}
                                                                                                    disabled={!portfolioStates[portfolioIndex]?.private?.find(p => p.id === portfolio.id)?.checked}
                                                                                                    inputProps={{ maxLength: 6 }}
                                                                                                    thousandSeparator={true}
                                                                                                    allowNegative={false}
                                                                                                />
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    ))}
                                                                                </Grid>
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={12} lg={12} className='text-center p-1'>
                                                                                <Button
                                                                                    variant='outlined'
                                                                                    color="primary"
                                                                                    size="small"
                                                                                    // className='raintree-btn-green'
                                                                                    onClick={() => saveEnhancementPortfolio(portfolioIndex, openSelectBoxes[portfolioIndex])}
                                                                                    sx={{ marginTop: 2 }}
                                                                                >
                                                                                    Save
                                                                                </Button>
                                                                            </Grid>
                                                                        </Paper>
                                                                    </>
                                                                ) : ''}
                                                            </Grid>


                                                            <Grid item xs={12} lg={6} sx={{ paddingLeft: '16px', paddingRight: '16px' }}>
                                                                <Grid item xs={12}>
                                                                    <label className="font14px label-text">Notes</label>
                                                                </Grid>

                                                                {/* Notes Input */}
                                                                <Grid item xs={12}>
                                                                    <InputBase
                                                                        className="textarea-mui"
                                                                        name="sup_changes_income"
                                                                        id="sup_changes_income"
                                                                        value={portfolioData.chartData.account_portfolio_note}
                                                                        placeholder="Notes"
                                                                        multiline
                                                                        minRows={3}
                                                                        maxRows={5}
                                                                        fullWidth
                                                                        onChange={(e) => handleNoteChange(e, portfolioIndex)}
                                                                    />
                                                                </Grid>


                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={() => handleSaveNotes(portfolioIndex)}
                                                                        sx={{ mt: 2 }}
                                                                    >
                                                                        Save Notes
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                            {/* ------------- graph -------------------- */}

                                                            <Grid item container spacing={1} xs={12} className='mt-2' >
                                                                <Grid item xs={12} sm={6}>
                                                                    <DonutChart
                                                                        seriesValue={portfolioData.chartValue}
                                                                        labelTitle={portfolioData.chartTitle}
                                                                        total={0}
                                                                        centerTitle={portfolioData.chartData.portfolio_name}
                                                                        dataFormat="percentage"
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} sx={{ padding: '16px' }}>
                                                                    {portfolioData.chartData?.category.map((row, index) => (
                                                                        <div className='chart-asset-category' key={index}>
                                                                            <h6>{row.category}</h6>
                                                                            <ul>
                                                                                {portfolioData.chartData?.assets.map((asset, assetIndex) => {
                                                                                    const showingChart = row.id === asset.category;
                                                                                    return (
                                                                                        showingChart &&
                                                                                        asset.value > 0 && (
                                                                                            <li key={assetIndex} className='padding5px'>
                                                                                                <span>
                                                                                                    {asset.title} : {asset.value}%
                                                                                                </span>
                                                                                            </li>
                                                                                        )
                                                                                    );
                                                                                })}
                                                                            </ul>
                                                                        </div>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>

                                                        </div>
                                                    </div>
                                                </div>

                                            </Grid>
                                        </Grid>

                                    </>
                                )
                            })}

                            <div className="card mt-3">

                                <div className="card-header bg-light">
                                    <h5 className="mt-0 label-text font14px">Rationale</h5>
                                </div>

                                <div className="card-body mt-2">
                                    <div className="row g-4 justify-content-start">

                                        {questionnaireNotesArray.map((label, index) => (
                                            <div className="col-md-6" key={index}>
                                                <div>
                                                    <label
                                                        className="form-label fw-semibold"
                                                        htmlFor={`sup_changes_income_${index}`}
                                                    >
                                                        {label}
                                                    </label>

                                                    <InputBase
                                                        className="form-control"
                                                        name={`sup_changes_income_${index}`}
                                                        id={`sup_changes_income_${index}`}
                                                        value={titleNotes[index] || ""}
                                                        placeholder="Enter your response..."
                                                        multiline
                                                        minRows={3}
                                                        maxRows={5}
                                                        fullWidth
                                                        onChange={(e) =>
                                                            handleTitleNoteChange(e, index)
                                                        }
                                                    />

                                                </div>

                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>

                            <Grid className="card-body">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={emailNotificationStatus}
                                            onChange={(e) => setEmailNotificationStatus(e.target.checked)}
                                        />
                                    }
                                    label="Send an email notification for approval to  Admin and Head office AR"
                                />
                            </Grid>

                        </>
                    )}

                    {/* <Divider variant="middle" /> */}
                    <Grid item xs={12} sm={12} className='text-center' >
                        <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                            Back
                        </Button>
                        <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleNextStep}>
                            Next
                        </Button>
                    </Grid>
                </div>
            </div >
            {loader}
            < ToastContainer />
        </>
    )
}

export default RiskQuestionnaire;
